import { render, staticRenderFns } from "./GatVesselSelect.vue?vue&type=template&id=20959633&scoped=true&"
import script from "./GatVesselSelect.vue?vue&type=script&lang=js&"
export * from "./GatVesselSelect.vue?vue&type=script&lang=js&"
import style0 from "./GatVesselSelect.vue?vue&type=style&index=0&id=20959633&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20959633",
  null
  
)

export default component.exports